import MUIDataTable, { MUIDataTableColumnDef, MUIDataTableOptions } from 'mui-datatables';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../../../core/hooks';
import { StatisticsTableChartOptions } from '../../../chart-settings/components';
import { ChartSettingsInteractionModel } from '../../../chart-settings/hooks';
import { MonitoredDeviceModel } from '../../model';
import { CpeStatisticsTableRow } from '../CpeStatisticsTableRow/CpeStatisticsTableRow';
import { formatNumberWithTwoFractionDigits } from '../../../timeseries-statistics/NumberFormatter';
import { DEFAULT_LANGUAGE } from '../../../../core/config';

interface Props {
  customerId: number | null;
  monitoredDevices: MonitoredDeviceModel[];
  chartSettingsInteraction: ChartSettingsInteractionModel;
}

const displayWithTwoFractionDigits = (value?: number): string =>
  formatNumberWithTwoFractionDigits(value, DEFAULT_LANGUAGE.code, '');

export const CpeStatisticsTable: FunctionComponent<Props> = ({
  monitoredDevices,
  customerId,
  chartSettingsInteraction,
}) => {
  const translate = useAppTranslate();
  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'serviceName',
      label: translate('tableHeaders.serviceName')
    },
    {
      name: 'orderNumber',
      label: translate('tableHeaders.sozId')
    },
    {
      name: 'deviceName',
      label: translate('tableHeaders.device')
    },
    {
      name: 'cpuUsage',
      label: translate('tableHeaders.cpuUsage'),
      options: {
        customBodyRender: (cpuUsage: number) => displayWithTwoFractionDigits(cpuUsage)
      }
    },
    {
      name: 'availability',
      label: translate('tableHeaders.availability'),
      options: {
        customBodyRender: (availability: number) => displayWithTwoFractionDigits(availability)
      }
    }
  ];

  const options: MUIDataTableOptions = {
    enableNestedDataAccess: '.',
    selectToolbarPlacement: 'none',
    download: false,
    print: false,
    rowHover: false,
    expandableRows: true,
    selectableRows: 'none',
    expandableRowsHeader: false,
    renderExpandableRow: (rowData, rowMeta) =>
      <CpeStatisticsTableRow
        device={monitoredDevices[rowMeta.dataIndex]}
        chartSettings={chartSettingsInteraction.chartSettings}
        customerId={customerId}
      />,
  };

  return <>
    <StatisticsTableChartOptions chartSettingsInteraction={chartSettingsInteraction} />
    <MUIDataTable
      title={''}
      columns={columns}
      data={monitoredDevices}
      options={options}
    />
  </>;
};